
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"#4A4A4A"}},[_c('path',{attrs:{"d":"M9.23 16.5H2.309a.76.76 0 01-.77-.75V2.25a.76.76 0 01.77-.75H9.23A.76.76 0 0010 .75.76.76 0 009.23 0H2.309C1.035 0 0 1.01 0 2.25v13.5C0 16.99 1.035 18 2.308 18H9.23a.76.76 0 00.769-.75.76.76 0 00-.77-.75z"}}),_c('path',{attrs:{"d":"M17.778 8.94L13.24 4.227a.72.72 0 00-1.055.008.814.814 0 00.008 1.111l3.242 3.37H6.746c-.412 0-.746.35-.746.785 0 .434.334.786.746.786h8.69l-3.243 3.369a.815.815 0 00-.008 1.11.728.728 0 00.531.235c.19 0 .38-.075.524-.226l4.538-4.715A.808.808 0 0018 9.5c0-.21-.08-.41-.222-.558z"}})])])
          )
        }
      }
    